import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Row,
  Col,
  Button,
  Drawer,
  Form,
  Select,
  Radio,
  DatePicker,
  message,
} from "antd";
import {
  CANCEL_REQUEST,
  FILTER_DATE_RANGES,
  BIDDING_STATUS_TYPE,
} from "constants/index";
import generalService from "../../services/general.service";
import axios from "axios";

const { Option } = Select;
const initialValues = {
  status: 0,
};

const Filter = ({ onHide, show = false, onSearch }) => {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [form] = Form.useForm();
  const globalSetting = useSelector((state) => state.appReducer.globalSetting);

  const search = () => {
    form
      .validateFields()
      .then((params) => {
        console.log(params);
        onSearch(params);
      })
      .catch((e) => {
        message.warning("Please check the form validation");
      });
    onHide(false);
  };

  const onClear = () => {
    form.setFieldsValue(initialValues);
  };

  return (
    <>
      <Drawer
        title="Filter results"
        width={330}
        onClose={() => onHide(false)}
        visible={show}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button onClick={onClear} style={{ marginRight: 8 }}>
              Clear
            </Button>
            <Button onClick={search} type="primary">
              Search
            </Button>
          </div>
        }
      >
        <Form layout="vertical" initialValues={initialValues} form={form}>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="status"
                label="Status"
                rules={[{ required: true, message: "Status is required" }]}
              >
                <Select
                  placeholder="Status"
                  value={selectedStatus}
                  onSelect={(val, op) => {
                    setSelectedStatus(op);
                  }}
                >
                  {BIDDING_STATUS_TYPE.map((item, index) => {
                    return (
                      <Option key={index + item.label} value={item.value}>
                        {item.label}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
};

export default Filter;
